import {
  DELETE_ARTICLE_AND_FAQS,
  GET_ARTICLES_DATA_SUCCESS,
  GET_OFFERS_DATA_SUCCESS,
  LOGOUT_SUCCESS,
} from "../Types";

const initalState = {
  offersData: [],
  articlesData: [],
};

export default function dashboardReducer(state = initalState, action) {
  switch (action.type) {
    case GET_OFFERS_DATA_SUCCESS: {
      return {
        ...state,
        offersData: action.body.data,
      };
    }
    case GET_ARTICLES_DATA_SUCCESS: {
      return {
        ...state,
        articlesData: action.body.data,
      };
    }
    case DELETE_ARTICLE_AND_FAQS: {
      return {
        ...state,
        articlesData: [],
      };
    }
    case LOGOUT_SUCCESS: {
      return { ...initalState };
    }
    default:
      return state;
  }
}
